import { useEffect } from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import TrustBar from "@/components/landing/TrustBar";
import Problem from "@/components/landing/Problem";
import Services from "@/components/landing/Services";
import WhoWeServe from "@/components/landing/WhoWeServe";
import Process from "@/components/landing/Process";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    document.querySelectorAll(".xw-reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[var(--xw-bg)]">
      <Nav />
      <main>
        <Hero />
        <TrustBar />
        <Problem />
        <Services />
        <WhoWeServe />
        <Process />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
